<div fxLayout="row">
  <div
    fxLayout="column"
    [fxFlex]="
      (breakpointService.isPhoneViewObservable | async) ? '60px' : '50px'
    "
    fxLayoutAlign="center center"
  >
    <div class="icon-container">
      <div class="linked-line"></div>

      <div class="icon-wrapper" [class.active]="isActive">
        <div class="content">
          <mat-icon>{{ data?.icon }}</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!(breakpointService.isPhoneViewObservable | async)"
    fxLayout="column"
    fxFlex="auto"
    fxLayoutAlign="center start"
  >
    <lib-spacer></lib-spacer>

    <div class="title">
      {{ data?.title | translate }}
    </div>

    <lib-spacer [height]="5"></lib-spacer>

    <div class="description">
      {{ data?.description | translate }}
    </div>
  </div>
</div>
